var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDripLineTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5 h15v15h-15z",
    fill: "#fff",
    stroke: "#7826ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5h14v14H5z",
    fill: "#7826ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDripLineTour);
export default __webpack_public_path__ + "static/media/drip-line-tour.face0d5c1d412cd802e2c0fa1fc8b53f.svg";
export { ForwardRef as ReactComponent };